export default __webpack_public_path__ + "static/media/item_ex_1.71413912.png";